import { AddImage } from "./AddImage/AddImage";
import { Download } from "./Download/Download";
import { Settings } from "./Settings/Settings";

export const BottomMenu = () => {
    return (
        <div className="py-4 pl-4 pr-5 dark:border-t dark:border-t-darkSurface-600">
            <div className="bg-irBlue-200 rounded-xl flex items-center justify-center gap-4">
                <AddImage />
                <Settings />
                <Download />
            </div>
        </div>
    );
};
